import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import StyledOrderCards from "./StyledOrderCards";
import { ORDER_CARD_CONSTANTS } from "../../constants/lang";
import ShimmerLoader from "../../components/CommonComponents/Loader/ShimmerLoader";


const OrderCard = ({ dashboardData, loading }) => {
  const cardData = [
    { title: ORDER_CARD_CONSTANTS.totalProducts, value: dashboardData?.total_products || dashboardData?.data?.total_products || 0 },
    { title: ORDER_CARD_CONSTANTS.newOrders, value: dashboardData?.new_orders || dashboardData?.data?.new_orders || 0 },
    { title: ORDER_CARD_CONSTANTS.activeOrders, value: dashboardData?.active_orders || dashboardData?.data?.active_orders || 0 },
    { title: ORDER_CARD_CONSTANTS.completedOrders, value: dashboardData?.completed_orders || dashboardData?.data?.completed_orders || 0 },
    { title: ORDER_CARD_CONSTANTS.cancelledOrders, value: dashboardData?.cancelled_orders || dashboardData?.data?.cancelled_orders || 0 },
  ];

  return (
    <StyledOrderCards>
      <Grid container spacing={2} className="order-card-container">
        {cardData.map((item, index) => (
          <Grid
            item
            xs={index === 3 || index === 4 ? 6 : 4}
            sm={2.4}
            md={2.4}
            lg={2.4}
            key={index}
          >
            <Card className="order-card">
              <CardContent className="order-card-content">
                <Typography className="order-card-title">
                  {item.title}
                </Typography>
                <Typography className="order-card-value">
                  {loading ?
                    <ShimmerLoader /> :
                    item.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </StyledOrderCards>
  );
};

export default OrderCard;
